<template>
  <div class="login-out-view">
    <b-container v-if="!hasPhone">
      <div class="login-view">
        <h5>手机号码登录</h5>
        <p>未注册的手机号验证后将自动创建新账号</p>
        <b-form @submit="onSubmit">
          <b-form-group id="phone" label-for="phone" class="login-input">
            <b-form-input
              id="input-phone"
              v-model="form.phone"
              placeholder="手机号码"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="code"
            label-for="code"
            class="login-input login-code"
          >
            <b-form-input
              id="input-phone"
              v-model="form.code"
              placeholder="验证码"
              required
            ></b-form-input>
            <b-button @click="onVerification" :disabled="disableVal">{{
              time
            }}</b-button>
          </b-form-group>
          <b-button
            :disabled="disabled"
            class="login-button"
            :class="[
              disabled ? 'login-button-disable' : 'login-button-undisable'
            ]"
            type="submit"
            block
            >登录</b-button
          >
          <b-form-checkbox v-model="check" class="login-check">
            <p>
              我已阅读并同意<router-link to="/privacy"
                >法律声明及隐私权政策</router-link
              >
            </p>
          </b-form-checkbox>
        </b-form>
        <div class="login-towx" @click="switchActive('wx')">
          <i></i>
          <a>微信扫码登录</a>
        </div>
      </div>

      <!-- <div v-if="active == 1" class="login-wx">
        <h6>微信扫码登录</h6>
        <p>未注册用户绑定微信登录</p>
        <img src />
        <span></span>
        <div class="login-tophone">
          <a @click="switchActive('login')">手机号码登录</a>
        </div>
      </div>-->
    </b-container>
    <b-container v-if="hasPhone" class="login-wx">
      <img src="@/assets/img/new/footer/wx.png" />
      <p>微信扫一扫进入小程序</p>
    </b-container>
    <b-container
      class="login-logo"
      @click="
        () => {
          this.$router.push('/');
        }
      "
      style="cursor:pointer"
    >
      <img src="@/assets/img/new/logo.png" />
    </b-container>
  </div>
</template>
<script>
import Api from "@/apis";
export default {
  data() {
    return {
      hasPhone: false,
      active: 0,
      status: this.$route.query.status || "",
      id: this.$route.query.id || null,
      redirect: this.$route.query.redirect || null,
      disableVal: false,
      disabled: true,
      check: false,
      time: "发送验证码",
      form: {
        phone: "",
        code: ""
      }
    };
  },
  watch: {
    form: {
      handler(val) {
        if (val.phone == "" || val.code == "" || !this.check) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
      deep: true
    },
    check: {
      handler(val) {
        if (this.form.phone == "" || this.form.code == "" || !val) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loginWxchat();
    if (this._isMobile()) {
      this.hasPhone = true;
    } else {
      this.hasPhone = false;
    }
    if (this.redirect != null) {
      localStorage.setItem("redirect", this.redirect);
    }
    console.log("redirect url: ", this.redirect);
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    async onSubmit(event) {
      event.preventDefault();
      let token = sessionStorage.getItem("login_token");
      let query = {
        mobile: this.form.phone,
        code: this.form.code,
        token: token
      };
      try {
        const data = await Api.Login.LoginMobile(query);
        if (data.accessToken) {
          this.$message.success("登录成功");
          localStorage.setItem("token", JSON.stringify(data));
          const _redirect = localStorage.getItem("redirect");
          console.log("mobile redirect:", _redirect);
          if (_redirect != null) {
            localStorage.removeItem("redirect");
            location.href = _redirect;
          } else {
            this.$router.go(-1);
          }
        }
      } catch (e) {
        this.$message.error(e, "验证码错误");
      }
    },
    async onVerification() {
      if (this.form.phone == "") {
        this.$message.error("请先输入手机号");
        return false;
      } else {
        let query = {
          mobile: this.form.phone,
          tpl: "login_verify_code"
        };
        try {
          const data = await Api.Login.getVerification(query);
          sessionStorage.setItem("login_token", data.token);
        } catch (e) {
          this.$message.error(e, "验证码获取错误");
        }
        let time = 60;
        let timer = setInterval(() => {
          time--;
          this.time = `${time}秒后重试`;
          this.disableVal = true;
          if (time == 0) {
            clearInterval(timer);
            this.time = "发送验证码";
            this.disableVal = false;
          }
        }, 1000);
      }
    },
    async switchActive(val) {
      if (!this.check) {
        this.$message.error("请先同意《法律声明及隐私权政策》");
      } else {
        switch (val) {
          case "wx":
            try {
              const url = "http%3a%2f%2fwww.huicaihuineng.com%2flogin";
              const data = await Api.Login.LoginWeChatScan(url);
              window.location.href = data;
            } catch (e) {
              this.$message.error(e, "微信登录错误");
            }
            break;
          case "login":
            this.active = 0;
            break;
        }
      }
    },
    //获取路由后携带code值进行登录
    async loginWxchat() {
      let router = this.$route.query;
      if (router.code) {
        try {
          const data = await Api.Login.LoginWeChat(
            "wx33bc1debb6840ca0",
            router.code
          );
          if (data.accessToken) {
            const _redirect = localStorage.getItem("redirect");
            console.log("wx redirect:", _redirect);
            if (_redirect != null) {
              localStorage.removeItem("redirect");
              location.href = _redirect;
            } else {
              this.$router.push("/");
            }
            this.$message.success("登录成功");
          }
          localStorage.setItem("token", JSON.stringify(data));
        } catch (e) {
          this.$message.error("微信登录失败" || e);
          this.$router.push({ query: {} });
        }
      }
    }
  }
};
</script>
<style scoped></style>
